import Landscape from "../Components/Landscape";

export default function LandscapeContainer() {
  return <Landscape />;
}
